"use client";

import React, { useState } from 'react';
import { User, Phone, ArrowRight, ArrowLeft, CheckCircle2, Edit2, Loader2, MessageCircle, Mail, Send, Users, Heart, Activity, AlertCircle } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { createStatelessSessionAction } from '@/actions/session-actions';
import { sendOtpAction, verifyOtpAction } from '@/actions/sms-actions';
import { useOfferStore } from '@/store/useOfferStore';
import Dialog from '@/components/common/Dialog';

export default function Page() {
    const router = useRouter();

    // ZUSTAND STORE'DAN FONKSİYONU ÇEK
    const setOfferData = useOfferStore((state) => state.setOfferData);

    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [apiLoading, setApiLoading] = useState(false);
    const [customError, setCustomError] = useState<string | null>(null);
    const [editMode, setEditMode] = useState({
        personal: false,
        health: false
    });

    // İletişim form state
    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });
    const [isContactSubmitted, setIsContactSubmitted] = useState(false);
    const [isContactLoading, setIsContactLoading] = useState(false);
    const [contactError, setContactError] = useState("");

    // Form state
    const [isFamily, setIsFamily] = useState(false);
    const [tcKimlikNo, setTcKimlikNo] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [gender, setGender] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    // Kişisel bilgiler
    const [personalInfo, setPersonalInfo] = useState({
        name: "",
        surname: "",
        job: "",
        email: "",
        phone: "",
        tcKimlikNo: tcKimlikNo,
        birthDate: birthDate,
        gender: gender
    });

    // Sağlık bilgileri
    const [healthInfo, setHealthInfo] = useState({
        height: "",
        weight: ""
    });

    // Aile üyeleri
    const [familyMembers, setFamilyMembers] = useState<any[]>([]);
    const [showAddMemberModal, setShowAddMemberModal] = useState(false);
    const [newMember, setNewMember] = useState({
        name: "",
        surname: "",
        tcKimlikNo: "",
        birthDate: "",
        gender: "",
        type: "",
        height: "",
        weight: ""
    });

    const handleNextStep = async () => {
        if (step === 1) {
            // Temel bilgiler doğrulama
            if (!tcKimlikNo || !birthDate || !gender) {
                setCustomError('Lütfen tüm zorunlu alanları doldurun');
                return;
            }
            setStep(2);
        }
        else if (step === 2) {
            // Kişisel bilgiler doğrulama
            if (!personalInfo.name || !personalInfo.surname) {
                setCustomError('Lütfen ad ve soyad bilgilerinizi girin');
                return;
            }
            setStep(3);
        }
        else if (step === 3) {
            // Sağlık bilgileri - zorunlu değil, direkt geç
            setStep(4);
        }
        else if (step === 4) {
            // Aile üyeleri - zorunlu değil, direkt teklif al (YENİ SİSTEM)
            await saveSession();
        }
    };

    const handlePrevStep = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };

    // --- YENİ ZUSTAND VE ŞİFRELİ TOKEN SİSTEMİ ---
    const saveSession = async () => {
        setApiLoading(true);
        try {
            const sessionData = {
                personalInfo: {
                    ...personalInfo,
                    tcKimlikNo,
                    birthDate,
                    gender
                },
                healthInfo,
                familyMembers,
                formData: {
                    tcKimlikNo,
                    birthDate,
                    gender,
                    phoneNumber,
                    isFamily
                },
                type: 'TamamlayiciSaglik' // Sunucunun beklediği tip
            };

            // 1. Veritabanına YAZMADAN şifreli token oluştur
            const result = await createStatelessSessionAction(sessionData);

            if (!result.success || !result.token) {
                throw new Error(result.error || "Token oluşturulamadı");
            }

            // 2. Teklifler sayfasında ekranda güvenle göstermek için özet bilgiler
            const safeDisplayData = {
                type: 'TamamlayiciSaglik',
                name: personalInfo.name,
                surname: personalInfo.surname,
                birthDate: birthDate,
                gender: gender === 'E' ? 'Erkek' : gender === 'K' ? 'Kadın' : '-',
                isFamily: isFamily,
                familyMemberCount: familyMembers.length
            };

            // 3. Zustand ile RAM'e kaydet (F5 atılınca silinir)
            setOfferData(result.token, safeDisplayData);

            // 4. Teklifler sayfasına yönlendir
            router.push("/teklif-al/teklifler");

        } catch (error: any) {
            setCustomError("Teklifler sayfasına yönlenirken hata oluştu: " + error.message);
        } finally {
            setApiLoading(false);
        }
    };

    // Aile üyesi ekleme
    const handleAddMember = () => {
        if (!newMember.tcKimlikNo || !newMember.birthDate || !newMember.gender || !newMember.type) {
            setCustomError("Lütfen zorunlu alanları doldurun");
            return;
        }

        setFamilyMembers([...familyMembers, { ...newMember }]);
        setNewMember({
            name: "",
            surname: "",
            tcKimlikNo: "",
            birthDate: "",
            gender: "",
            type: "",
            height: "",
            weight: ""
        });
        setShowAddMemberModal(false);
    };

    // İletişim formu gönderme (TİPLER EKLENDİ)
    const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsContactLoading(true);
        setContactError("");

        try {
            const response = await fetch('/api/contact/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...contactForm,
                    type: 'TSS',
                    subject: 'Tamamlayıcı Sağlık Sigortası Talebi'
                }),
            });

            const result = await response.json();

            if (response.ok && result.success) {
                setIsContactSubmitted(true);
                setContactForm({ name: "", email: "", phone: "", message: "" });
                setTimeout(() => setIsContactSubmitted(false), 5000);
            } else {
                setContactError(result.error || 'Mesajınız gönderilemedi. Lütfen tekrar deneyin.');
            }
        } catch (error) {
            setContactError('Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.');
        } finally {
            setIsContactLoading(false);
        }
    };

    // TİPLER EKLENDİ
    const handleContactChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setContactForm({ ...contactForm, [e.target.name]: e.target.value });
        setContactError("");
    };

    // Tarih formatı
    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR');
    };

    // Cinsiyet seçenekleri
    const genders = [
        { label: "Kadın", value: "K" },
        { label: "Erkek", value: "E" }
    ];

    // Aile üyesi tipleri
    const memberTypes = [
        { label: "Eş", value: "spouse" },
        { label: "Çocuk", value: "child" }
    ];

    return (
        <section className="flex-col flex items-center justify-center bg-linear-to-br from-green-50 via-white to-blue-50 overflow-hidden">
            {/* Dekoratif arkaplan elementleri */}
            <div className="absolute top-0 left-0 w-full h-1/2 bg-linear-to-b from-green-100/50 to-transparent"></div>
            <div className="absolute top-20 left-10 w-72 h-72 bg-green-400/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-600/15 rounded-full blur-3xl"></div>
            <div className="absolute inset-0 bg-[radial-gradient(#d1f8e8_1px,transparent_1px)] [bg-size:24px_24px]"></div>

            <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 pb-16 px-4">
                <div className="container relative z-10 mx-auto max-w-7xl flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-16">

                    {/* Sol Taraf - Açıklama */}
                    <div className="w-full lg:w-1/2 text-center lg:text-left">
                        <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-100 text-green-700 text-sm font-medium mb-6">
                            <Heart className="w-4 h-4 mr-2" /> Tamamlayıcı Sağlık Sigortası
                        </div>

                        <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-6">
                            Sağlığınızı <span className="text-green-600">Güvence Altına Alın</span>
                        </h1>
                        <p className="text-lg text-gray-600 mb-8">
                            Özel hastanelerde ek masraflarla karşılaşmayın.
                            Geniş hastane ağı ve kapsamlı teminatlar ile sağlığınız güvende.
                        </p>

                        {/* İlerleme Çubuğu */}
                        <div className="mb-8">
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-sm text-gray-600">Adım {step}/4</span>
                                <span className="text-sm text-gray-600">%{step * 25}</span>
                            </div>
                            <div className="w-full bg-green-200 rounded-full h-2">
                                <div
                                    className="bg-green-600 h-2 rounded-full transition-all duration-300"
                                    style={{ width: `${step * 25}%` }}
                                ></div>
                            </div>
                        </div>

                        {/* Adım Açıklamaları */}
                        <div className="space-y-4">
                            <div className={`flex items-center ${step >= 1 ? 'text-green-600' : 'text-gray-400'}`}>
                                <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-3 ${step >= 1 ? 'bg-green-600 text-white' : 'bg-gray-300'}`}>
                                    {step > 1 ? <CheckCircle2 className="w-4 h-4" /> : '1'}
                                </div>
                                <span className="font-medium">Temel Bilgiler</span>
                            </div>
                            <div className={`flex items-center ${step >= 2 ? 'text-green-600' : 'text-gray-400'}`}>
                                <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-3 ${step >= 2 ? 'bg-green-600 text-white' : 'bg-gray-300'}`}>
                                    {step > 2 ? <CheckCircle2 className="w-4 h-4" /> : '2'}
                                </div>
                                <span className="font-medium">Kişisel Bilgiler</span>
                            </div>
                            <div className={`flex items-center ${step >= 3 ? 'text-green-600' : 'text-gray-400'}`}>
                                <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-3 ${step >= 3 ? 'bg-green-600 text-white' : 'bg-gray-300'}`}>
                                    {step > 3 ? <CheckCircle2 className="w-4 h-4" /> : '3'}
                                </div>
                                <span className="font-medium">Sağlık Bilgileri</span>
                            </div>
                            <div className={`flex items-center ${step >= 4 ? 'text-green-600' : 'text-gray-400'}`}>
                                <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-3 ${step >= 4 ? 'bg-green-600 text-white' : 'bg-gray-300'}`}>
                                    4
                                </div>
                                <span className="font-medium">Özet & Teklifler</span>
                            </div>
                        </div>
                    </div>

                    {/* Sağ Taraf - Form */}
                    <div className="w-full lg:w-1/2 max-w-md">
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-green-100/50 p-8">

                            {/* Adım 1: Temel Bilgiler */}
                            {step === 1 && (
                                <div className="space-y-6">
                                    <div className="flex items-center justify-center mb-2">
                                        <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center mr-3">
                                            <User className="w-5 h-5 text-white" />
                                        </div>
                                        <h2 className="text-2xl font-semibold text-gray-800">
                                            Temel Bilgiler
                                        </h2>
                                    </div>
                                    <p className="text-gray-600 text-center mb-6">
                                        Lütfen temel kimlik bilgilerinizi giriniz
                                    </p>

                                    {/* Sigorta Türü Seçimi */}
                                    <div className="mb-6">
                                        <label className="block text-sm font-medium text-gray-700 mb-3">
                                            Sigorta Türü
                                        </label>
                                        <div className="grid grid-cols-2 gap-3">
                                            <button
                                                onClick={() => setIsFamily(false)}
                                                className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${!isFamily
                                                    ? 'border-green-600 bg-green-50 text-green-700'
                                                    : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400'
                                                    }`}
                                            >
                                                Kendim İçin
                                            </button>
                                            <button
                                                onClick={() => setIsFamily(true)}
                                                className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${isFamily
                                                    ? 'border-green-600 bg-green-50 text-green-700'
                                                    : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400'
                                                    }`}
                                            >
                                                Ailem İçin
                                            </button>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                TC Kimlik No
                                            </label>
                                            <input
                                                type="text"
                                                value={tcKimlikNo}
                                                onChange={(e) => setTcKimlikNo(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                placeholder="TC Kimlik Numaranız"
                                                maxLength={11}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Doğum Tarihi
                                            </label>
                                            <input
                                                type="date"
                                                value={birthDate}
                                                onChange={(e) => setBirthDate(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Cinsiyet
                                            </label>
                                            <select
                                                value={gender}
                                                onChange={(e) => setGender(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                            >
                                                <option value="">Cinsiyet seçin</option>
                                                {genders.map(gender => (
                                                    <option key={gender.value} value={gender.value}>
                                                        {gender.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Telefon Numarası
                                            </label>
                                            <div className="relative">
                                                <input
                                                    type="tel"
                                                    value={phoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                    className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                    placeholder="5XX XXX XX XX"
                                                />
                                                <Phone className="absolute right-3 top-3.5 w-5 h-5 text-gray-400" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex gap-4">
                                        <button
                                            onClick={handlePrevStep}
                                            className="flex-1 bg-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-400 transition-colors flex items-center justify-center"
                                        >
                                            <ArrowLeft className="w-5 h-5 mr-2" />
                                            Geri
                                        </button>
                                        <button
                                            onClick={handleNextStep}
                                            className="flex-1 bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-lg shadow-green-200 flex items-center justify-center"
                                        >
                                            <span>Devam Et</span>
                                            <ArrowRight className="w-5 h-5 ml-2" />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Adım 2: Kişisel Bilgiler */}
                            {step === 2 && (
                                <div className="space-y-6">
                                    <div className="flex items-center justify-center mb-2">
                                        <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center mr-3">
                                            <User className="w-5 h-5 text-white" />
                                        </div>
                                        <h2 className="text-2xl font-semibold text-gray-800">
                                            Kişisel Bilgiler
                                        </h2>
                                    </div>
                                    <p className="text-gray-600 text-center mb-6">
                                        Lütfen kişisel bilgilerinizi tamamlayınız
                                    </p>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Ad</label>
                                            <input
                                                type="text"
                                                value={personalInfo.name}
                                                onChange={(e) => setPersonalInfo({ ...personalInfo, name: e.target.value })}
                                                className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                placeholder="Adınız"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Soyad</label>
                                            <input
                                                type="text"
                                                value={personalInfo.surname}
                                                onChange={(e) => setPersonalInfo({ ...personalInfo, surname: e.target.value })}
                                                className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                placeholder="Soyadınız"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">E-posta</label>
                                            <div className="relative">
                                                <input
                                                    type="email"
                                                    value={personalInfo.email}
                                                    onChange={(e) => setPersonalInfo({ ...personalInfo, email: e.target.value })}
                                                    className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                    placeholder="E-posta adresiniz"
                                                />
                                                <Mail className="absolute right-3 top-3.5 w-5 h-5 text-gray-400" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex gap-4">
                                        <button
                                            onClick={handlePrevStep}
                                            className="flex-1 bg-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-400 transition-colors flex items-center justify-center"
                                        >
                                            <ArrowLeft className="w-5 h-5 mr-2" />
                                            Geri
                                        </button>
                                        <button
                                            onClick={handleNextStep}
                                            className="flex-1 bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-lg shadow-green-200 flex items-center justify-center"
                                        >
                                            <span>Devam Et</span>
                                            <ArrowRight className="w-5 h-5 ml-2" />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Adım 3: Sağlık Bilgileri */}
                            {step === 3 && (
                                <div className="space-y-6">
                                    <div className="flex items-center justify-center mb-2">
                                        <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center mr-3">
                                            <Activity className="w-5 h-5 text-white" />
                                        </div>
                                        <h2 className="text-2xl font-semibold text-gray-800">
                                            Sağlık Bilgileri
                                        </h2>
                                    </div>
                                    <p className="text-gray-600 text-center mb-6">
                                        Bu bilgiler teklifiniz için gereklidir (zorunlu değil)
                                    </p>

                                    <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 mb-6">
                                        <div className="flex items-center">
                                            <div className="w-6 h-6 bg-blue-500 rounded-full items-center justify-center mr-3 flex">
                                                <Activity className="w-3 h-3 text-white" />
                                            </div>
                                            <p className="text-blue-800 text-sm">
                                                Bu alanların doldurulması zorunlu <span className="underline font-semibold">değildir.</span>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex gap-4">
                                            <div className="flex-1">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Boy (cm)</label>
                                                <input
                                                    type="number"
                                                    value={healthInfo.height}
                                                    onChange={(e) => setHealthInfo({ ...healthInfo, height: e.target.value })}
                                                    className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                    placeholder="Boy"
                                                    maxLength={3}
                                                />
                                            </div>
                                            <div className="flex-1">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Kilo (kg)</label>
                                                <input
                                                    type="number"
                                                    value={healthInfo.weight}
                                                    onChange={(e) => setHealthInfo({ ...healthInfo, weight: e.target.value })}
                                                    className="w-full px-4 py-3 border border-gray-300 placeholder:text-gray-400 text-gray-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                                                    placeholder="Kilo"
                                                    maxLength={3}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex gap-4">
                                        <button
                                            onClick={handlePrevStep}
                                            className="flex-1 bg-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-400 transition-colors flex items-center justify-center"
                                        >
                                            <ArrowLeft className="w-5 h-5 mr-2" />
                                            Geri
                                        </button>
                                        <button
                                            onClick={handleNextStep}
                                            className="flex-1 bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-lg shadow-green-200 flex items-center justify-center"
                                        >
                                            <span>Devam Et</span>
                                            <ArrowRight className="w-5 h-5 ml-2" />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Adım 4: Özet ve Teklifler */}
                            {step === 4 && (
                                <div className="space-y-6">
                                    <div className="flex items-center justify-center mb-2">
                                        <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center mr-3">
                                            <CheckCircle2 className="w-5 h-5 text-white" />
                                        </div>
                                        <h2 className="text-2xl font-semibold text-gray-800">
                                            Bilgilerinizi Kontrol Edin
                                        </h2>
                                    </div>
                                    <p className="text-gray-600 text-center mb-6">
                                        Bilgileriniz doğruysa teklifleri alabilirsiniz
                                    </p>

                                    {/* Kişisel Bilgiler */}
                                    <div className="bg-green-50 rounded-xl p-4 border border-green-200">
                                        <div className="flex justify-between items-center mb-3">
                                            <h3 className="font-semibold text-gray-800">Kişisel Bilgiler</h3>
                                            <button
                                                onClick={() => setEditMode(prev => ({ ...prev, personal: !prev.personal }))}
                                                className="flex items-center text-green-600 hover:text-green-700 text-sm"
                                            >
                                                <Edit2 className="w-4 h-4 mr-1" />
                                                {editMode.personal ? 'Kaydet' : 'Düzenle'}
                                            </button>
                                        </div>

                                        {editMode.personal ? (
                                            <div className="space-y-3">
                                                <input
                                                    type="text"
                                                    value={personalInfo.name}
                                                    onChange={e => setPersonalInfo({ ...personalInfo, name: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                                    placeholder="Ad"
                                                />
                                                <input
                                                    type="text"
                                                    value={personalInfo.surname}
                                                    onChange={e => setPersonalInfo({ ...personalInfo, surname: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                                    placeholder="Soyad"
                                                />
                                                <input
                                                    type="email"
                                                    value={personalInfo.email}
                                                    onChange={e => setPersonalInfo({ ...personalInfo, email: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                                    placeholder="E-posta"
                                                />
                                            </div>
                                        ) : (
                                            <div className="space-y-2 text-sm">
                                                <div className="flex justify-between">
                                                    <span className="text-gray-700">Ad Soyad:</span>
                                                    <span className="font-medium text-gray-600">{personalInfo.name} {personalInfo.surname}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-gray-700">TC Kimlik No:</span>
                                                    <span className="font-medium text-gray-600">{tcKimlikNo}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-gray-700">Doğum Tarihi:</span>
                                                    <span className="font-medium text-gray-600">{formatDate(birthDate)}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-gray-700">Cinsiyet:</span>
                                                    <span className="font-medium text-gray-600">
                                                        {gender === 'E' ? 'Erkek' : gender === 'K' ? 'Kadın' : '-'}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Sağlık Bilgileri */}
                                    <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
                                        <div className="flex justify-between items-center mb-3">
                                            <h3 className="font-semibold text-gray-800">Sağlık Bilgileri</h3>
                                            <button
                                                onClick={() => setEditMode(prev => ({ ...prev, health: !prev.health }))}
                                                className="flex items-center text-blue-600 hover:text-blue-700 text-sm"
                                            >
                                                <Edit2 className="w-4 h-4 mr-1" />
                                                {editMode.health ? 'Kaydet' : 'Düzenle'}
                                            </button>
                                        </div>

                                        {editMode.health ? (
                                            <div className="space-y-3">
                                                <div className="flex gap-3">
                                                    <input
                                                        type="number"
                                                        value={healthInfo.height}
                                                        onChange={e => setHealthInfo({ ...healthInfo, height: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                                        placeholder="Boy (cm)"
                                                    />
                                                    <input
                                                        type="number"
                                                        value={healthInfo.weight}
                                                        onChange={e => setHealthInfo({ ...healthInfo, weight: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                                        placeholder="Kilo (kg)"
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="space-y-2 text-sm">
                                                <div className="flex justify-between">
                                                    <span className="text-gray-700">Boy:</span>
                                                    <span className="font-medium text-gray-600">{healthInfo.height || '-'} cm</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-gray-700">Kilo:</span>
                                                    <span className="font-medium text-gray-600">{healthInfo.weight || '-'} kg</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Aile Üyeleri */}
                                    {isFamily && (
                                        <div className="bg-purple-50 rounded-xl p-4 border border-purple-200">
                                            <div className="flex justify-between items-center mb-3">
                                                <h3 className="font-semibold text-gray-800">Aile Üyeleri</h3>
                                                <button
                                                    onClick={() => setShowAddMemberModal(true)}
                                                    className="flex items-center text-purple-600 hover:text-purple-700 text-sm"
                                                >
                                                    <Users className="w-4 h-4 mr-1" />
                                                    Ekle
                                                </button>
                                            </div>

                                            {familyMembers.length > 0 ? (
                                                <div className="space-y-2">
                                                    {familyMembers.map((member, index) => (
                                                        <div key={index} className="flex justify-between items-center text-sm">
                                                            <span className="text-gray-700">
                                                                {member.type === 'spouse' ? 'Eş' : 'Çocuk'} - {member.tcKimlikNo}
                                                            </span>
                                                            <span className="font-medium text-gray-600">
                                                                {formatDate(member.birthDate)}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-gray-500 text-sm">Henüz aile üyesi eklenmedi</p>
                                            )}
                                        </div>
                                    )}

                                    <button
                                        onClick={handleNextStep}
                                        disabled={apiLoading}
                                        className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 disabled:bg-green-400 transition-colors shadow-lg shadow-green-200 flex items-center justify-center"
                                    >
                                        {apiLoading ? (
                                            <>
                                                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                                                <span>Teklifler Alınıyor...</span>
                                            </>
                                        ) : (
                                            <>
                                                <span>Teklifleri Al</span>
                                                <ArrowRight className="w-5 h-5 ml-2" />
                                            </>
                                        )}
                                    </button>

                                    <button
                                        onClick={handlePrevStep}
                                        className="w-full bg-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-400 transition-colors flex items-center justify-center"
                                    >
                                        <ArrowLeft className="w-5 h-5 mr-2" />
                                        Geri Dön
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Aile Üyesi Ekleme Modal */}
                {showAddMemberModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-2xl p-6 w-full max-w-md">
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">Yeni Aile Üyesi</h3>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Üye Türü</label>
                                    <select
                                        value={newMember.type}
                                        onChange={(e) => setNewMember({ ...newMember, type: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                    >
                                        <option value="">Seçiniz</option>
                                        {memberTypes.map(type => (
                                            <option key={type.value} value={type.value}>{type.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">TC Kimlik No</label>
                                    <input
                                        type="text"
                                        value={newMember.tcKimlikNo}
                                        onChange={(e) => setNewMember({ ...newMember, tcKimlikNo: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                        placeholder="TC Kimlik No"
                                        maxLength={11}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Doğum Tarihi</label>
                                    <input
                                        type="date"
                                        value={newMember.birthDate}
                                        onChange={(e) => setNewMember({ ...newMember, birthDate: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Cinsiyet</label>
                                    <select
                                        value={newMember.gender}
                                        onChange={(e) => setNewMember({ ...newMember, gender: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                    >
                                        <option value="">Seçiniz</option>
                                        {genders.map(gender => (
                                            <option key={gender.value} value={gender.value}>{gender.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex gap-3">
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Boy (cm)</label>
                                        <input
                                            type="number"
                                            value={newMember.height}
                                            onChange={(e) => setNewMember({ ...newMember, height: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                            placeholder="Boy"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Kilo (kg)</label>
                                        <input
                                            type="number"
                                            value={newMember.weight}
                                            onChange={(e) => setNewMember({ ...newMember, weight: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                            placeholder="Kilo"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-3 mt-6">
                                <button
                                    onClick={() => setShowAddMemberModal(false)}
                                    className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg font-medium"
                                >
                                    İptal
                                </button>
                                <button
                                    onClick={handleAddMember}
                                    className="flex-1 bg-green-600 text-white py-2 rounded-lg font-medium"
                                >
                                    Ekle
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <Dialog
                    isVisible={!!customError}
                    message={customError}
                    type="error"
                    duration={5000}
                    onClose={() => setCustomError(null)}
                />
            </section>

            {/* İletişim Formu Bölümü */}
            <section className="w-full py-16 px-4 relative overflow-hidden">
                <div className="max-w-4xl mx-auto">
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-green-100/50 overflow-hidden">
                        <div className="bg-linear-to-r from-green-600 to-green-700 p-6 text-white">
                            <div className="flex items-center justify-center">
                                <MessageCircle className="w-6 h-6 mr-3" />
                                <h2 className="text-2xl font-bold">Size Ulaşalım</h2>
                            </div>
                            <p className="text-green-100 text-center mt-2">
                                Tamamlayıcı sağlık sigortası hakkında detaylı bilgi almak için formu doldurun.
                            </p>
                        </div>

                        <div className="p-8">
                            {contactError && (
                                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-start">
                                    <AlertCircle className="h-5 w-5 text-red-500 mr-3 mt-0.5 shrink-0" />
                                    <div>
                                        <p className="text-red-800 font-medium">Hata</p>
                                        <p className="text-red-700 text-sm">{contactError}</p>
                                    </div>
                                </div>
                            )}

                            {isContactSubmitted ? (
                                <div className="text-center py-8">
                                    <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto mb-4" />
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Talebiniz Alındı!</h3>
                                    <p className="text-gray-600 mb-4">
                                        Sağlık sigortası uzmanımız en kısa sürede sizinle iletişime geçecek.
                                    </p>
                                </div>
                            ) : (
                                <form onSubmit={handleContactSubmit} className="space-y-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                <User className="inline h-4 w-4 mr-1" />
                                                Adınız Soyadınız
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={contactForm.name}
                                                onChange={handleContactChange}
                                                className="w-full px-4 py-3 border text-gray-600 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                required
                                                disabled={isContactLoading}
                                                placeholder="Adınız ve soyadınız"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                <Phone className="inline h-4 w-4 mr-1" />
                                                Telefon Numaranız
                                            </label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={contactForm.phone}
                                                onChange={handleContactChange}
                                                className="w-full px-4 py-3 border text-gray-600 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                                required
                                                disabled={isContactLoading}
                                                placeholder="5XX XXX XX XX"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <Mail className="inline h-4 w-4 mr-1" />
                                            E-posta Adresiniz
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={contactForm.email}
                                            onChange={handleContactChange}
                                            className="w-full px-4 py-3 border text-gray-600 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            required
                                            disabled={isContactLoading}
                                            placeholder="E-posta adresiniz"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <MessageCircle className="inline h-4 w-4 mr-1" />
                                            Mesajınız
                                        </label>
                                        <textarea
                                            name="message"
                                            value={contactForm.message}
                                            onChange={handleContactChange}
                                            rows={4}
                                            className="w-full px-4 py-3 border text-gray-600 placeholder-gray-400 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                                            placeholder="Tamamlayıcı sağlık sigortası hakkında bilgi almak istediğiniz konuları yazın..."
                                            required
                                            disabled={isContactLoading}
                                        ></textarea>
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={isContactLoading}
                                        className="w-full bg-green-600 text-white py-4 px-6 rounded-xl font-semibold hover:bg-green-700 transition-colors duration-300 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-green-200"
                                    >
                                        {isContactLoading ? (
                                            <>
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                                Gönderiliyor...
                                            </>
                                        ) : (
                                            <>
                                                <Send className="h-5 w-5 mr-2" />
                                                Bilgi Talebi Gönder
                                            </>
                                        )}
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
}